<template>
  <div>
    <el-input :size="size" placeholder="请设置数据" :value="text" readonly>
      <table class="property-field-table" cellspacing="0" cellpadding="0" slot="append">
        <tr>
          <td @click="clear">&times;</td>
          <td @click="toSet">设置数据</td>
        </tr>
      </table>
    </el-input>
    <json-child-list-setter-dialog ref="jsonChildListSetterDialog" @save="onSave"></json-child-list-setter-dialog>
  </div>
</template>

<script>
import JsonChildListSetterDialog from '../model/JsonChildListSetterDialog'

export default {
  name: 'json-child-list-setter-button',
  components: {
    JsonChildListSetterDialog
  },
  props: {
    property: { type: Object, required: true },
    size: { type: String, required: false, default: 'mini' },
    columns: { type: Array, required: true }
  },
  data () {
    return {
      text: ''
    }
  },
  watch: {
    'property.value': {
      handler: function (val) {
        if (!val) {
          this.text = ''
        } else {
          let datas = JSON.parse(val)
          this.text = `已设置${datas.length}条`
        }
      },
      immediate: true
    }
  },
  methods: {
    clear () {
      this.property.value = undefined
      this.text = ''
      this.$emit('change')
    },
    toSet () {
      let val = this.property.value
      this.$refs.jsonChildListSetterDialog.open(this.columns, val ? JSON.parse(val) : [])
    },
    onSave (datas) {
      this.property.value = JSON.stringify(datas)
      this.text = `已设置${datas.length}条`
      this.$emit('change')
    }
  }
}
</script>
